import React from 'react';
import styled from 'styled-components';
import StructuredText from '~/App/components/DatoCMS/StructuredText';
import {
  Maybe,
  ObjectServiceModelContentField
} from '~/config/generated/graphql';

const StructuredTextWrapper = styled.div`
  & > p:first-child {
    margin: 0 !important;
  }
`;

interface Props {
  data?: Maybe<ObjectServiceModelContentField>;
}

export const ServiceStructuredText = ({ data }: Props) => {
  return <StructuredText data={data} wrapper={StructuredTextWrapper} />;
};
